
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import ActivitySettingsEditor from './ActivitySettingsEditor';

@Component({
  components: {
    ActivitySettingsEditor,
  },
})
export default class ActivitySettingsCard extends Vue {
  save(): void {
    (this.$refs.editor as ActivitySettingsEditor).save();
  }
}
